module.exports = __webpack_public_path__ + "img/symbol_18_normal.61becb79.png";